(() => {
  const settings = document.getElementById('add-to-cart-alert-settings');
  if (!settings || settings.dataset.mode === 'never') return;

  let toast;
  let timer;

  function showAlert(product) {
    let container = document.getElementById('alert-container-header');
    if (!container) {
      container = document.createElement('div');
      container.id = 'alert-container-header';
      (document.querySelector('header, .header, #shopify-section-header') || document.body).appendChild(container);
    }

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'add-to-cart-toast';
      toast.className = 'success alert';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      toast.style.setProperty('--cart-alert-border', settings.dataset.border);
      toast.style.setProperty('--cart-alert-background', settings.dataset.background);
      toast.innerHTML = '<div class="content"><div class="icon" aria-hidden="true">' +
        '<img src="https://cdn.shopify.com/s/files/1/0827/4935/8383/files/check_spin.png?v=1761539487" alt="">' +
        '</div><p id="toast-text"></p></div>';
    }

    container.appendChild(toast);
    const title = (product.product_title || product.title || 'producto').trim();
    // Text content keeps merchant messages and product names out of HTML.
    toast.querySelector('#toast-text').textContent = settings.dataset.message
      .split('[product_title]').join(title);
    toast.classList.add('show');
    clearTimeout(timer);
    timer = setTimeout(() => {
      toast.classList.remove('show');
      toast.remove();
    }, 2500);
  }

  function shouldShowAlert() {
    if (settings.dataset.mode === 'always') return true;
    return settings.dataset.mode === 'search_results' &&
      window.location.pathname.replace(/\/$/, '') === '/search' &&
      new URLSearchParams(window.location.search).has('q');
  }

  function isCartAdd(url, method) {
    try {
      const target = new URL(url, window.location.href);
      const cartAdd = new URL(window.theme?.routes?.cart_add_url || '/cart/add.js', window.location.origin);
      const normalize = path => path.replace(/\/$/, '').replace(/\.js$/, '');
      return method.toUpperCase() === 'POST' && target.origin === window.location.origin &&
        normalize(target.pathname) === normalize(cartAdd.pathname);
    } catch {
      return false;
    }
  }

  function handleSuccess(payload) {
    if (!shouldShowAlert() || !payload || payload.status || payload.errors) return;
    const product = Array.isArray(payload.items) ? payload.items[0] : payload;
    if (product?.id) showAlert(product);
  }

  // Observe Shopify's cart API, including requests made by third-party search apps.
  // Keep the original response available to the caller and do not alter the cart drawer.
  const originalFetch = window.fetch;
  window.fetch = async function(input, init) {
    const eligible = shouldShowAlert() && isCartAdd(
      input instanceof Request ? input.url : input,
      init?.method || (input instanceof Request ? input.method : 'GET')
    );
    const response = await originalFetch.call(this, input, init);
    if (eligible && response.ok) {
      response.clone().json().then(handleSuccess).catch(() => {});
    }
    return response;
  };

  const requestInfo = Symbol('cartAlertRequest');
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this[requestInfo] = { method, url };
    return originalOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(...args) {
    const request = this[requestInfo];
    if (request && shouldShowAlert() && isCartAdd(request.url, request.method)) {
      this.addEventListener('loadend', () => {
        if (this.status < 200 || this.status >= 300) return;
        try {
          handleSuccess(this.responseType === 'json' ? this.response : JSON.parse(this.responseText));
        } catch {
          // A non-JSON or aborted response must not produce a success alert.
        }
      }, { once: true });
    }
    return originalSend.apply(this, args);
  };
})();
